import { produce } from 'immer';
import { uniq, keyBy } from 'lodash';

import {
  SET_CUSTOMER_PORTFOLIO_ITEMS,
  SET_PROFILE_LOADING,
  SET_PROFILE_ERROR,
  TOGGLE_ITEM_SELECT,
  REMOVE_ITEM,
  SET_CUSTOMER_BUYING_STATS,
  SET_CUSTOMER_SELLING_STATS,
  CLEAR_SELECTED_ITEMS,
  FETCH_CUSTOMER_PORTFOLIO_ITEMS,
  SET_CUSTOMER_SELLING_ITEM_IDS,
  DUMP_PORRTFOLIO_ITEMS,
  SET_SELECTED_ITEMS,
  CLEAR_ITEMS,
  SET_PORTFOLIO_ITEM_SHIP_BY_DATE,
} from '../profile/actions';

import { PORTFOLIO_ITEM_SUCCESS } from './actions';

const idSets = [
  'chainIds',
  'buying-current-ids',
  'buying-pending-ids',
  'buying-history-ids',
  'selling-current-ids',
  'selling-pending-ids',
  'selling-history-ids',
  'selectedItemIds',
  'searchResultIds',
];

const removeFromAllIdSets = (draft, idToRemove) => {
  idSets.forEach((idSet) => {
    draft[idSet] = draft[idSet].filter((id) => id !== idToRemove);
  });
};

const emptyPortfolio = {
  'buying-current-ids': [],
  'buying-pending-ids': [],
  'buying-history-ids': [],
  'selling-current-ids': [],
  'selling-pending-ids': [],
  'selling-history-ids': [],
};

export const INITIAL_STATE = {
  ...emptyPortfolio,
  byChainId: {},
  chainIds: [],
  searchResultIds: [],
  selectedItemIds: [],
  'buying-current-paging': {},
  'buying-pending-paging': {},
  'buying-history-paging': {},
  'selling-current-paging': {},
  'selling-pending-paging': {},
  'selling-history-paging': {},
  'loading-buying-current': false,
  'loading-buying-pending': false,
  'loading-buying-history': false,
  'loading-selling-current': false,
  'loading-selling-pending': false,
  'loading-selling-history': false,

  'error-buying-current': '',
  'error-buying-pending': '',
  'error-buying-history': '',
  'error-selling-current': '',
  'error-selling-pending': '',
  'error-selling-history': '',
  stats: {
    buying: {},
    selling: {},
  },
  showBulkAction: null,
  search: '',
};

export const portfolioReducer = (
  state = INITIAL_STATE,
  { type, payload }: any = {},
) =>
  produce(state, (draft) => {
    switch (type) {
      case PORTFOLIO_ITEM_SUCCESS: {
        const { chainId } = payload;

        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
        draft.chainIds.push(chainId);
        draft.byChainId[`${chainId}`] = payload;
        return draft;
      }

      case FETCH_CUSTOMER_PORTFOLIO_ITEMS: {
        draft[`loading-${payload.type}-${payload.status}`] = true;
        return draft;
      }

      case CLEAR_ITEMS: {
        return {
          ...draft,
          ...emptyPortfolio,
        };
      }

      case SET_CUSTOMER_PORTFOLIO_ITEMS: {
        const arraySet = `${payload.type}-${payload.status}-ids`;
        if (
          draft.search !== payload.search ||
          !payload.paging.page ||
          payload.paging.page === 1
        ) {
          draft.searchResultIds = [];
        }

        if (
          payload.items?.length &&
          (!payload.paging.page || payload.paging.page === 1)
        ) {
          draft[arraySet] = [];
        }

        draft.search = payload.search;

        payload.items.forEach((portfolioItem) => {
          const { chainId } = portfolioItem;
          draft[arraySet].push(chainId);
          // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
          draft.chainIds.push(chainId);

          draft.byChainId[`${chainId}`] = portfolioItem;

          if (payload.search) {
            // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
            draft.searchResultIds.push(chainId);
          }
        });

        draft[arraySet] = uniq(draft[arraySet]);
        draft.chainIds = uniq(draft.chainIds);

        draft[`loading-${payload.type}-${payload.status}`] = false;
        draft[`error-${payload.type}-${payload.status}`] = false;

        draft[`${payload.type}-${payload.status}-paging`] = payload.paging;
        return draft;
      }

      case SET_PROFILE_LOADING:
        draft[`loading-${payload.type}-${payload.status}`] = true;
        return draft;
      case SET_PROFILE_ERROR:
        draft[`loading-${payload.type}-${payload.status}`] = false;
        draft[`error-${payload.type}-${payload.status}`] = payload.errorText;
        return draft;
      case SET_CUSTOMER_BUYING_STATS:
        draft.stats.buying = payload.buying;
        return draft;
      case SET_CUSTOMER_SELLING_STATS:
        draft.stats.selling = payload.selling;
        return draft;
      case TOGGLE_ITEM_SELECT:
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
        if (state.selectedItemIds.includes(`${payload.item.chainId}`)) {
          draft.selectedItemIds = state.selectedItemIds.filter(
            (chain) => chain !== `${payload.item.chainId}`,
          );
        } else if (state.selectedItemIds.length < 100) {
          // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
          draft.selectedItemIds.push(`${payload.item.chainId}`);
        }

        return draft;
      case SET_SELECTED_ITEMS:
        draft.selectedItemIds = payload.items.map(({ chainId }) => chainId);
        draft.byChainId = {
          ...draft.byChainId,
          ...payload.items.reduce((keyedItems, item) => {
            const { chainId } = item;
            return { ...keyedItems, [chainId]: item };
          }, {}),
        };
        return draft;
      case CLEAR_SELECTED_ITEMS:
        draft.selectedItemIds = [];
        // @ts-expect-error ts-migrate(2322) FIXME: Type 'false' is not assignable to type 'null'.
        draft.showBulkAction = false;
        return draft;
      case REMOVE_ITEM:
        delete draft.byChainId[`${payload.chainId}`];
        removeFromAllIdSets(draft, payload.chainId);
        return draft;
      case SET_CUSTOMER_SELLING_ITEM_IDS:
        draft['selling-current-ids'] = payload.current;
        draft['selling-pending-ids'] = payload.pending;
        return draft;
      case DUMP_PORRTFOLIO_ITEMS:
        // eslint-disable-next-line no-case-declarations
        const keyedItems = keyBy(payload.items, 'chainId');
        draft.byChainId = {
          ...draft.byChainId,
          ...keyedItems,
        };
        return draft;
      case SET_PORTFOLIO_ITEM_SHIP_BY_DATE: {
        const { chainId, extendedShipByDate } = payload;
        draft.byChainId[`${chainId}`].shipByDate = extendedShipByDate;
        draft.byChainId[`${chainId}`].shippingExtensionRequested = true;
        return draft;
      }

      default:
        return draft;
    }
  });
